import { render, staticRenderFns } from "./BaseEmailPart.vue?vue&type=template&id=45ecae58&lang=pug"
import script from "./BaseEmailPart.vue?vue&type=script&lang=ts"
export * from "./BaseEmailPart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports